import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import "../../styles/css/ElevationForm/elevationForm.css";

import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";

class SectionG extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { sectionG, onClickG, validateG } = this.props;
    return (
      <div className="form-wrapper-elevation">
        <h2>COMMUNITY INFORMATION (OPTIONAL)</h2>
        {sectionG.isSubmittedG === false ? (
          <div className="err-msg-content">
            Something went wrong. Please try again.
          </div>
        ) : null}

        <table>
          <tbody>
            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <p className="sub-question-title">
                    The local official who is authorized by law or ordinance to
                    administer the community's floodplain management ordinance
                    can complete Sections A, B, C (or E), and G of this
                    Elevation Certificate. Complete the applicable item(s) and
                    sign below. Check the measurement used in Items G8–G10. In
                    Puerto Rico only, enter meters.
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <div className="checkbox-wrapper-main">
                  <span>G1.</span>
                  <div>
                    <input
                      checked={sectionG.item_g1 === "G1"}
                      type="checkbox"
                      name="item_g1"
                      value="G1"
                      onChange={onClickG}
                      className="check-item"
                    />
                  </div>

                  <label>
                    The information in Section C was taken from other
                    documentation that has been signed and sealed by a licensed
                    surveyor, engineer, or architect who is authorized by law to
                    certify elevation information. (Indicate the source and date
                    of the elevation data in the Comments area below.)
                  </label>
                </div>

                <div className="checkbox-wrapper-main">
                  <span>G2.</span>
                  <div>
                    <input
                      checked={sectionG.item_g2 === "G2"}
                      type="checkbox"
                      name="item_g2"
                      value="G2"
                      onChange={onClickG}
                      className="check-item"
                    />
                  </div>

                  <label>
                    A community official completed Section E for a building
                    located in Zone A (without a FEMA-issued or community-issued
                    BFE) or Zone AO.
                  </label>
                </div>

                <div className="checkbox-wrapper-main">
                  <span>G3.</span>
                  <div>
                    <input
                      checked={sectionG.item_g3 === "G3"}
                      type="checkbox"
                      name="item_g3"
                      value="G3"
                      onChange={onClickG}
                      className="check-item"
                    />
                  </div>

                  <label>
                    The following information (Items G4–G10) is provided for
                    community floodplain management purposes.
                  </label>
                </div>

                {/* {validateG.message(
                  "values",
                  sectionG.comunity_item,
                  "alpha_num_dash_space",
                  { className: "error-msg-text" }
                )} */}
              </td>
            </tr>

            <tr>
              <td colSpan="2">
                <div className="question-wrapper">
                  <span>G4.</span>
                  <p className="qst-type">Permit Number</p>
                </div>
              </td>
              <td colSpan="2">
                <div className="question-wrapper">
                  <span>G5.</span>
                  <p className="qst-type">Date Permit Issued</p>
                </div>
              </td>
              <td colSpan="2">
                <div className="question-wrapper">
                  <span>G6.</span>
                  <p className="qst-type">
                    Date Certificate of Compliance/Occupancy Issued
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    name="permit_no"
                    value={sectionG.permit_no}
                    onChange={onClickG}
                    className="form-input-box"
                  />
                  {validateG.message(
                    "permit no",
                    sectionG.permit_no,
                    "numeric|min:0,num",
                    { className: "error-msg-text" }
                  )}
                </div>
              </td>
              <td colSpan="2">
                <div className="input-box-wrapper">
                  <input
                    type="date"
                    name="permit_issues_for"
                    value={sectionG.permit_issues_for}
                    onChange={onClickG}
                    className="form-input-box"
                  />
                  {validateG.message(
                    "date",
                    sectionG.permit_issues_for,
                    "alpha_num_dash_space",
                    { className: "error-msg-text" }
                  )}
                </div>
              </td>
              <td colSpan="2">
                <div className="input-box-wrapper">
                  <input
                    type="date"
                    name="date_certificate_compliance"
                    value={sectionG.date_certificate_compliance}
                    onChange={onClickG}
                    className="form-input-box"
                  />
                  {validateG.message(
                    "date certificate compliance",
                    sectionG.date_certificate_compliance,
                    "alpha_num_dash_space",
                    { className: "error-msg-text" }
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <span>G7.</span>
                  <label className="qst-type">
                    This permit has been issued for:
                  </label>
                  <div className="checkbox-container">
                    <input
                      checked={sectionG.permit_case === "New contruction"}
                      type="radio"
                      name="permit_case"
                      value="New contruction"
                      onChange={onClickG}
                      className="checkbox-icon-btn"
                    />{" "}
                    <span className="checkbox-label">New Construction</span>
                    <input
                      checked={
                        sectionG.permit_case === "Substantial Improvement"
                      }
                      type="radio"
                      name="permit_case"
                      value="Substantial Improvement"
                      onChange={onClickG}
                      className="checkbox-icon-btn"
                    />{" "}
                    <span className="checkbox-label">
                      Substantial Improvement
                    </span>
                    {validateG.message(
                      "permit case",
                      sectionG.permit_case,
                      "alpha_num_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <span>G8.</span>
                  <label className="qst-type">
                    Elevation of as-built lowest floor (including basement) of
                    the building:
                  </label>
                  <div>
                    <input
                      type="text"
                      name="basement_elevation"
                      value={sectionG.basement_elevation}
                      onChange={onClickG}
                      className="input-area-small"
                    />
                    {validateG.message(
                      "value",
                      sectionG.basement_elevation,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                  <div>
                    <div className="checkbox-container">
                      <input
                        type="radio"
                        checked={sectionG.basement_elevation_unit === "feet"}
                        name="basement_elevation_unit"
                        value="feet"
                        onChange={onClickG}
                        className="checkbox-icon-btn"
                      />

                      <span className="checkbox-label">feet</span>

                      <input
                        type="radio"
                        checked={sectionG.basement_elevation_unit === "meters"}
                        name="basement_elevation_unit"
                        value="meters"
                        onChange={onClickG}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">meters</span>
                      <span className="checkbox-label">Datum</span>
                    </div>
                    {validateG.message(
                      "value",
                      sectionG.basement_elevation_unit,
                      "alpha_num_dash_space",
                      { className: "error-msg-radio" }
                    )}
                  </div>

                  <div>
                    {" "}
                    <input
                      name="basement_elevation_datum"
                      value={sectionG.basement_elevation_datum}
                      onChange={onClickG}
                      type="text"
                      className="input-area-small"
                    />
                    {validateG.message(
                      "value",
                      sectionG.basement_elevation_datum,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <span>G9.</span>
                  <label className="qst-type">
                    BFE or (in Zone AO) depth of flooding at the building site:
                  </label>
                  <div>
                    <input
                      name="static_BFE"
                      value={sectionG.static_BFE}
                      onChange={onClickG}
                      type="text"
                      className="input-area-small"
                    />
                    {validateG.message(
                      "value",
                      sectionG.bfe_depth,
                      "alpha_num_dash_space",
                      {
                        className: "error-msg-text",
                      }
                    )}
                  </div>
                  <div>
                    <div className="checkbox-container">
                      <input
                        type="radio"
                        name="bfe_depth_unit"
                        checked={sectionG.bfe_depth_unit === "feet"}
                        value="feet"
                        className="checkbox-icon-btn"
                        onChange={onClickG}
                      />
                      <span className="checkbox-label">feet</span>

                      <input
                        type="radio"
                        name="bfe_depth_unit"
                        checked={sectionG.bfe_depth_unit === "meters"}
                        value="meters"
                        onChange={onClickG}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">meters</span>
                      <span className="checkbox-label">Datum</span>
                    </div>
                    {validateG.message(
                      "value",
                      sectionG.bfe_depth_unit,
                      "alpha_num_dash_space",
                      { className: "error-msg-radio" }
                    )}
                  </div>
                  <div>
                    <input
                      type="text"
                      onChange={onClickG}
                      name="bfe_depth_datum"
                      value={sectionG.bfe_depth_datum}
                      className="input-area-small"
                    />
                    {validateG.message(
                      "value",
                      sectionG.bfe_depth_datum,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <span>G10.</span>
                  <label className="qst-type">
                    Community's design flood elevation:
                  </label>
                  <div>
                    <input
                      name="community_design"
                      value={sectionG.community_design}
                      onChange={onClickG}
                      type="text"
                      className="input-area-small"
                    />
                    {validateG.message(
                      "value",
                      sectionG.community_design,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>

                  <div>
                    <div className="checkbox-container">
                      <input
                        type="radio"
                        checked={sectionG.community_design_unit === "feet"}
                        name="community_design_unit"
                        value="feet"
                        onChange={onClickG}
                        className="checkbox-icon-btn"
                      />

                      <span className="checkbox-label">feet</span>

                      <input
                        checked={sectionG.community_design_unit === "meters"}
                        type="radio"
                        name="community_design_unit"
                        value="meters"
                        onChange={onClickG}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">meters</span>
                      <span className="checkbox-label">Datum</span>
                    </div>
                    {validateG.message(
                      "value",
                      sectionG.community_design_unit,
                      "alpha_num_dash_space",
                      { className: "error-msg-radio" }
                    )}
                  </div>

                  <div>
                    <input
                      name="community_design_datum"
                      value={sectionG.community_design_datum}
                      onChange={onClickG}
                      type="text"
                      className="input-area-small"
                    />
                    {validateG.message(
                      "value",
                      sectionG.community_design_datum,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="4">
                <div className="question-wrapper">
                  {" "}
                  <p className="sub-question-title">Local Official's Name</p>
                </div>

                <div className="input-box-wrapper">
                  <input
                    type="text"
                    name="local_officials_name"
                    value={sectionG.local_officials_name}
                    onChange={onClickG}
                    className="form-input-box"
                  />
                  {validateG.message(
                    "value",
                    sectionG.local_officials_name,
                    "alpha_num_dash_space",
                    { className: "error-msg-text" }
                  )}
                </div>
              </td>
              <td colSpan="2">
                <div className="question-wrapper">
                  {" "}
                  <p className="sub-question-title">Title</p>
                </div>

                <div className="input-box-wrapper">
                  <input
                    type="text"
                    name="local_officials_title"
                    value={sectionG.local_officials_title}
                    onChange={onClickG}
                    className="form-input-box"
                  />
                  {validateG.message(
                    "value",
                    sectionG.local_officials_title,
                    "alpha_num_space",
                    { className: "error-msg-text" }
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="4">
                <div className="question-wrapper">
                  {" "}
                  <p className="sub-question-title"> Community Name</p>
                </div>

                <div className="input-box-wrapper">
                  <input
                    name="local_officials_community_name"
                    value={sectionG.local_officials_community_name}
                    onChange={onClickG}
                    type="text"
                    className="form-input-box"
                  />
                  {validateG.message(
                    "value",
                    sectionG.local_officials_community_name,
                    "alpha_num_dash_space",
                    { className: "error-msg-text" }
                  )}
                </div>
              </td>
              <td colSpan="2">
                <div className="question-wrapper">
                  {" "}
                  <p className="sub-question-title">Telephone</p>
                </div>

                <div className="input-box-wrapper">
                  <input
                    name="local_officials_telephoe"
                    value={sectionG.local_officials_telephoe}
                    onChange={onClickG}
                    type="number"
                    className="form-input-box"
                  />
                  {validateG.message(
                    "value",
                    sectionG.local_officials_telephoe,
                    "numeric",
                    { className: "error-msg-text" }
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="4">
                <div className="question-wrapper">
                  {" "}
                  <p className="sub-question-title">Signature</p>
                </div>

                <div className="input-box-wrapper">
                  <input
                    disabled
                    name="local_officials_signature"
                    value={sectionG.local_officials_signature}
                    onChange={onClickG}
                    type="text"
                    className="form-input-box"
                  />
                </div>
              </td>
              <td colSpan="4">
                <div className="question-wrapper">
                  <p className="sub-question-title">Date</p>
                </div>

                <div className="input-box-wrapper">
                  <input
                    type="date"
                    name="local_officials_date"
                    value={sectionG.local_officials_date}
                    onChange={onClickG}
                    className="form-input-box"
                  />
                  {validateG.message(
                    "value",
                    sectionG.local_officials_date,
                    "alpha_num_dash_space",
                    { className: "error-msg-text" }
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <p className="sub-question-title">
                    Comments (including type of equipment and location, per
                    C2(e), if applicable)
                  </p>
                </div>
                <div className="input-box-wrapper">
                  <textarea
                    maxLength="1000"
                    name="comment_for_community"
                    value={sectionG.comment_for_community}
                    onChange={onClickG}
                    rows="14"
                    className="form-input-textarea"
                    placeholder=""
                  />{" "}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default SectionG;



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/SectionG.js